import { render, staticRenderFns } from "./RadioField.vue?vue&type=template&id=dd53b9fa&"
import script from "./RadioField.vue?vue&type=script&lang=js&"
export * from "./RadioField.vue?vue&type=script&lang=js&"
import style0 from "./RadioField.vue?vue&type=style&index=0&id=dd53b9fa&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dd53b9fa')) {
      api.createRecord('dd53b9fa', component.options)
    } else {
      api.reload('dd53b9fa', component.options)
    }
    module.hot.accept("./RadioField.vue?vue&type=template&id=dd53b9fa&", function () {
      api.rerender('dd53b9fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/radio/RadioField.vue"
export default component.exports